export default __webpack_public_path__ + "media/zurb/img/services/services/mobile-apps-img-05a7a68f6ee9b30cd48b1be83bc19c8f.png";